// extracted by mini-css-extract-plugin
export default {"form":"styles_form__v+0ak","descriptionButtons":"styles_descriptionButtons__PWTP+"};